import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Nurse icon
 *
 * @category Medical
 */
const Nurse = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M27.053 14.51c-.7-.52-1.74-.61-2.3-1.32-1.06-1.48-.23-4.96-2.37-5.7-3.5-.37-7.97-.03-11.5-.14-3.16-.39-2.66 3.58-3.5 5.57-.81 1.42-3.84 1.24-3.05 3.5.49 1.75 1.45 4.76 1.94 6.41.27 1.08.98 1.98 2.17 1.86h15.31c.56-.03 1-.17 1.36-.64.96-1.69 1.63-5.05 2.3-6.9.39-1.25.51-1.97-.24-2.54l-.12-.09zM9.493 8.64c.53-.53 1.57-.42 2.31-.45h4.87c1.89.19 4.02-.45 5.69.4.81.84.78 2.31.95 3.4.09 1.32-.63 1.06-1.82.63-1.85-.51-3.81-1.66-5.76-1.65-2.16.22-4.85 1.91-6.77 1.98-.28-.09-.34-.44-.28-.98.16-.99.25-2.4.74-3.22l.08-.1zm14.77 14.85c-1.75.58-3.56.14-5.96.27-3.71 0-7.803-.094-9.593-.094-.32 0-.608.003-.868-.187-1.26-1.39-1.746-4.736-2.366-6.616-.28-.97.208-1.7 1.138-2.02 3.05-.97 7.548-2.626 9.119-2.665s7.01 1.691 10.28 2.781c1.1.49.71 1.73.44 2.55-.64 1.72-1.06 4.58-2.09 5.9l-.1.07z"
        />
        <path
          fill="currentColor"
          d="M27.267 14.426c-.7-.52-1.74-.61-2.3-1.32-1.06-1.48-.23-4.96-2.37-5.7-3.5-.37-7.97-.03-11.5-.14-3.16-.39-2.66 3.58-3.5 5.57-.81 1.42-3.84 1.24-3.05 3.5.49 1.75 1.45 4.76 1.94 6.41.27 1.08.98 1.98 2.17 1.86h15.31c.56-.03 1-.17 1.36-.64.96-1.69 1.63-5.05 2.3-6.9.39-1.25.51-1.97-.24-2.54l-.12-.09zm-17.56-5.87c.53-.53 1.57-.42 2.31-.45h4.87c1.89.19 4.02-.45 5.69.4.81.84.78 2.31.95 3.4.09 1.32-.63 1.06-1.82.63-1.85-.51-3.81-1.66-5.76-1.65-2.16.22-4.85 1.91-6.77 1.98-.28-.09-.34-.44-.28-.98.16-.99.25-2.4.74-3.22l.08-.1zm14.77 14.85c-1.75.58-3.57.21-5.97.34-3.71 0-7.85-.06-9.64-.06-.32 0-.63-.05-.89-.24-1.26-1.39-1.82-4.82-2.44-6.7-.28-.97.31-1.78 1.24-2.1 3.05-.97 6.09-2.29 9.32-2.89 3.48.56 6.86 2.03 10.13 3.12 1.1.49.71 1.73.44 2.55-.64 1.72-1.06 4.58-2.09 5.9l-.1.07z"
        />
        <path
          fill="currentColor"
          d="M16.672 16.642a1 1 0 0 0 1 1h1.005a.5.5 0 0 1 0 1h-1.005a1 1 0 0 0-1 1v1.005a.5.5 0 1 1-1 0v-1.005a1 1 0 0 0-1-1h-.995a.5.5 0 1 1 0-1h.995a1 1 0 0 0 1-1v-.995a.5.5 0 1 1 1 0z"
        />
      </svg>
    );
  }
);

Nurse.displayName = 'Nurse';

export { Nurse };
